import { createConsumer } from '@rails/actioncable'

const CableApp = {}

CableApp.cable = createConsumer(
    `${window.knovApiUrl.replace('http', 'ws').replace('https', 'wss')}/cable`,
)

export default CableApp
